/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { InviteUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "UsersListPageService";
const log: any = LoggerModule.getInstance();

export class MasqueraderListPageService {
  private static instance: MasqueraderListPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): MasqueraderListPageService {
    if (!MasqueraderListPageService.instance) {
      MasqueraderListPageService.instance = new MasqueraderListPageService(
        props
      );
    }
    return MasqueraderListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }
    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    //UserLists Props
    // compProps = await agent.getUserListsProps({
    //   ...args,
    //   criteria: { ...this.criteria, ...args?.criteria },
    // });
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getMasqueraderListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async inviteUser(args: InviteUserProps) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getInviteUser(args);
  }

  public async deleteUser(args: any) {
    const agent = getAgent();
    return agent.getDeleteUser(args);
  }

  public async suspendUser(args: any) {
    log.info(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }

  public async activateUser(args: any) {
    log.info(`activate  user service`, args);
    const agent = getAgent();
    return agent.getActivateUser(args);
  }

  public async reInviteUser(args: any) {
    log.info(`reset user service`, args);
    const agent = getAgent();
    return agent.getReInviteUser(args);
  }

  public async getOneLabel(args: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getOneLabel(args);
    return content;
  }
  public async getBoxCount(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getBoxCountUser(args);
    console.log(compProps)
    return compProps;
  }
}
